import clsx from "clsx";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../common/buttons";
import { Icon } from "../common/Icon";

type Props = {
	id: string;
	title: string;
	message: string;
	loading?: boolean;
	onConfirm(): void;
	dangerButton?: boolean;
}

const ConfirmModal = forwardRef(({ id, title, message, loading, onConfirm, dangerButton }: Props, ref: any) => {
	const { t } = useTranslation();

	return (
		<div
			className="modal fade confirm-delete-modal"
			tabIndex={-1}
			id={id}
			data-bs-backdrop="static"
			data-bs-keyboard="false"
		>
			<div className="modal-dialog modal-dialog-centered justify-content-center">
				<div className="modal-content radius-12px">
					<div className="modal-header height-72px">
						<h5 className="modal-title text-gray-900">
							{t(title)}
						</h5>
						<div
							className="btn btn-icon btn-sm btn-active-light-primary ms-2"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							{/* <KTSVG
								path="/media/icons/duotune/arrows/arr061.svg"
								className="svg-icon svg-icon-2x"
							/> */}
							<Icon name="arrows/cross" className="svg-icon svg-icon-2x" />
						</div>
					</div>
					<div className="modal-body">
						<h5 className="modal-title text-gray-900" style={{ wordBreak: "break-word" }}>
							{message.split(/(?=[A-Z])/).join('\n')}
						</h5>
					</div>
					<div className="modal-footer height-72px">
						<button
							type="button"
							className="btn btn-light cancel-button button-height-42px button-width-115px"
							data-bs-dismiss="modal"
							disabled={loading}
							ref={ref}
						>
							{t('no')}
						</button>
						<PrimaryButton
							type="button"
							title={t('yes')}
							className={clsx('confirm-button button-height-42px button-width-115px', dangerButton && 'btn-danger')}
							loading={loading}
							onClick={onConfirm}
						/>
					</div>
				</div>
			</div>
		</div>
	);
});

export { ConfirmModal };
